<template>
    <div class="space-y-4">
        <button
            v-if="selectedZones.length"
            class="fixed top-14 right-[max(0.75rem,calc(50vw-20rem))] z-20 w-12 h-12 rounded-full bg-primary text-primary-fg shadow-lg flex items-center justify-center text-xl font-bold"
            @click="confirmZones"
        >
            ✓
        </button>

        <section>
            <h2 class="font-semibold">{{ t('zone.chooseZone') }}</h2>
            <div class="space-y-1">
                <AppCheckbox
                    v-for="zone in events.zones"
                    :key="zone.id"
                    v-model="selectedZones"
                    :value="Number(zone.id)"
                    :label="zone.name"
                />
            </div>
        </section>

        <AppButton v-if="selectedZones.length" block class="mt-4" @click="confirmZones">
            {{ t('zone.confirm') }}
        </AppButton>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useEventsStore } from '@/stores/events'
    import { useI18n } from 'vue-i18n'
    import AppCheckbox from '@/components/ui/AppCheckbox.vue'
    import AppButton from '@/components/ui/AppButton.vue'

    const events = useEventsStore()
    const router = useRouter()
    const { t } = useI18n()

    const selectedZones = ref<number[]>([...events.activeZones])

    function confirmZones() {
        events.setLastZones(null)
        events.setActiveEvents([])
        events.setActiveTicketsetIds([])
        events.setActiveCheckpoint(null)
        events.setActiveZones(selectedZones.value.map(Number))
        void router.push({ name: 'scanner' })
    }

    onMounted(async () => {
        try {
            await events.loadZones()
        } catch {
            // ignore — might be offline
        }
    })
</script>
